import { useState, useEffect } from "react";
import axios from "axios";
import AgentAuth from "./AgentAuth";
import AgentDashboard from "./AgentDashboard";
import { C } from "./theme";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
axios.defaults.withCredentials = true;

const AgentApp = () => {
  const [user, setUser] = useState(null); // null = checking, false = not authed, object = authed

  useEffect(() => {
    axios.get(`${API}/agents/auth/me`)
      .then(res => setUser(res.data))
      .catch(() => setUser(false));
  }, []);

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: C.bg }}>
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 rounded-full animate-spin" style={{ borderColor: `${C.border}`, borderTopColor: C.primary }} />
          <p className="text-sm" style={{ color: C.textMuted }}>Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <AgentAuth onLogin={setUser} />;
  }

  return (
    <AgentDashboard
      user={user}
      onLogout={async () => {
        try { await axios.post(`${API}/agents/auth/logout`); } catch { /* logout error */ }
        setUser(false);
      }}
    />
  );
};

export default AgentApp;
